// theme.ts
import { MantineThemeOverride } from '@mantine/core';
import '@fontsource/montserrat';

export const theme: MantineThemeOverride = {
    fontFamily: 'Montserrat, sans-serif',
    headings: {
        fontFamily: 'Montserrat, sans-serif',
    },
    primaryColor: 'red',
    colors: {
        red: [
            '#FFF0F0',
            '#FFD6D6',
            '#FFB3B3',
            '#FF8F8F',
            '#FF6B6B',
            '#FF4747',
            '#580A1B', // primary red
            '#4A0818',
            '#3B0615',
            '#2D0412',
        ],
        gray: [
            '#F8F8F8',
            '#EDEDED',
            '#DCDCDC',
            '#C8C8C8',
            '#B4B4B4',
            '#9F9F9F',
            '#6D6D6D', // primary gray
            '#5E5E5E',
            '#4F4F4F',
            '#404040',
        ],
        yellow: [
            '#FFF8E6',
            '#FFEDB8',
            '#FFE28A',
            '#FFD55C',
            '#FFC82E',
            '#FFC11A',
            '#FDB92E', // primary yellow
            '#D69F28',
            '#B18422',
            '#8A691C',
        ],
        blue: [
            '#E8F1F9',
            '#C9DAEE',
            '#AAC2E3',
            '#8BAACC',
            '#6C92B5',
            '#5A80A0',
            '#3A668C', // primary blue
            '#334F73',
            '#2C3A5A',
            '#252841',
        ],
        cream: [
            '#FFFFFF',
            '#FFFDF4',
            '#FFFBE9',
            '#FFF9DE',
            '#FFF7D3',
            '#FFF5C8',
            '#FEF5DA', // primary cream
            '#E6DBC0',
            '#D0C2A7',
            '#BAA98E',
        ],
        white: [
            '#FFFFFF',
            '#FEFEFF',
            '#FDFDFF',
            '#FCFCFE',
            '#FBFBFD',
            '#FAFAFC',
            '#ECEDEE', // primary white
            '#D1D1D3',
            '#B6B6B9',
            '#9B9B9F',
        ],
        darkGreen: [
            '#F0F8F0',
            '#E0F2E0',
            '#CCEBCD',
            '#B8E3B8',
            '#A4DDA4',
            '#90D790',
            '#6FA26C', // lush dark green
            '#5C8E5C',
            '#497A49',
            '#365536',
        ],
        green: [
            '#e6f9e6',
            '#ccf2cc',
            '#b3ebb3',
            '#99e499',
            '#80dd80',
            '#66d466',
            '#23d23d', // neon green (for special focus accents)
            '#1ebf1e',
            '#19a919',
            '#148414',
        ]
    },
};
